




















































































import { defineComponent } from '@vue/composition-api';
import { mapState } from 'vuex';
import RemoveDatabaseConnectionByAliasDialog from '@/views/integratorConfig/components/dialogs/RemoveDatabaseConnectionByAliasDialog.vue';
import CompanyRepository from '@/repositories/CompanyRepository';
import IntegratorDatabaseConnectionsRepository from '@/repositories/integrator/IntegratorDatabaseConnectionsRepository';
import InputRulesHelper from '@/helpers/InputRulesHelper';
import ISelectOptions from '@/domain/interfaces/ISelectOptions';
import DatabaseConnectionsConfigurationList from '@/domain/models/integrator/DatabaseConnectionsConfigurationList';

export default defineComponent({
  components: {
    RemoveDatabaseConnectionByAliasDialog,
  },
	name: 'IntegratorDatabaseConnectionConfigListTab',
	data() {
		const inputRules: InputRulesHelper = new InputRulesHelper();
		const companyRepository: CompanyRepository = new CompanyRepository();
		const integratorDatabaseConnectionsRepository:
      IntegratorDatabaseConnectionsRepository = new IntegratorDatabaseConnectionsRepository();

		const databaseConnectionsList: DatabaseConnectionsConfigurationList[] = [];
		const fieldTypeOptions: ISelectOptions<string>[] = [
			{ value: 'string', text: 'Texto' },
			{ value: 'date', text: 'Data' },
		];

		const loading: boolean = false;
    const removeIntegratorDialogOpen: boolean = false;

    const selectedDatabaseConnectionAlias: string|undefined = undefined;

		return {
      inputRules,
      integratorDatabaseConnectionsRepository,
			companyRepository,
      databaseConnectionsList,
			fieldTypeOptions,
			loading,
      removeIntegratorDialogOpen,
      selectedDatabaseConnectionAlias: selectedDatabaseConnectionAlias as string|undefined,
		};
	},
	computed: {
    ...mapState({
      companyGroupId: (state: any) => Number(state.authentication.user.company_group_id) as number,
    }),
    databaseConnectionAlias() {
      const databaseConnectionList = this
        .databaseConnectionsList as DatabaseConnectionsConfigurationList[];
      return databaseConnectionList.map(({ connectionAlias }) => connectionAlias);
    },
  },
	created() {
    this.getIntegratorDatabaseConnectionsData();
  },
	methods: {
    async getIntegratorDatabaseConnectionsData(): Promise<void> {
      try {
        this.loading = true;

        const databaseConnections = await this.integratorDatabaseConnectionsRepository
          .getDatabaseConnectionConfigurationsList(this.companyGroupId);

        this.databaseConnectionsList = databaseConnections;
      } catch (error) {
        const errorMessage = this.$helpers.extractAxiosErrorMessage(error, 'Houve um problema ao requisitar o arquivo de tabelas do integrador.');
        this.$notification.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    async deleteDatabaseConnectionOnFile(databaseAlias: string): Promise<void> {
      try {
        this.$dialog.startLoading();

        await this.integratorDatabaseConnectionsRepository
          .deleteDatabaseConnecitonConfiguration(this.companyGroupId, databaseAlias);
      } catch (error) {
        this.$notification.error('Houve um problema ao enviar os dados do arquivo de tabela.');
      } finally {
        this.$dialog.stopLoading();
      }
    },
    handleCreate(): void {
      this.$store.commit('integrator_config/setLastUpsertComponentOpened', 'IntegratorDatabaseConnectionConfigUpsert');

      this.$router.push({ name: 'IntegratorDatabaseConnectionConfigUpsert' });
    },
    handleEdit(databaseAlias: string): void {
      this.$store.commit('integrator_config/setDatabaseAliasToUpdate', databaseAlias);
      this.$store.commit('integrator_config/setLastUpsertComponentOpened', 'IntegratorDatabaseConnectionConfigUpsert');

      this.$router.push({ name: 'IntegratorDatabaseConnectionConfigUpsert' });
    },
    handleDelete(databaseAlias: string): void {
      this.removeIntegratorDialogOpen = true;
      this.selectedDatabaseConnectionAlias = databaseAlias;
    },
    handleCloseRemove(): void {
      this.removeIntegratorDialogOpen = false;
    },
    async handleOnSaveRemove(): Promise<void> {
      this.handleCloseRemove();

      await this.getIntegratorDatabaseConnectionsData();
    },
	},
});
